import { CCol, CRow } from '@coreui/react-pro'
import React from 'react'
import PropTypes from 'prop-types'
import { dateUSFormat } from '../../../utils/dateTimeUtils'

const DashboardHeader = ({ providerName }) => {
  const today = dateUSFormat(new Date().toISOString())
  let newProvider = providerName
  return (
    <div className="dash-header">
      <CRow>
        <CCol sm="9">
          <h1 className="title-name">
            Welcome{' '}
            {newProvider?.title === '' || !newProvider?.title ? (
              <span className="name">
                {newProvider?.first_name} {newProvider?.last_name}
              </span>
            ) : (
              <span className="name">
                {newProvider?.first_name} {newProvider?.last_name}
                {','} {newProvider?.title}
              </span>
            )}
          </h1>
        </CCol>
        <CCol sm="3">
          <h1 className="title-name">
            <small className="title-description">Today is {today}</small>
          </h1>
        </CCol>
      </CRow>
    </div>
  )
}

DashboardHeader.propTypes = {
  providerName: PropTypes.any,
}

export default DashboardHeader
